// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"4d2b00c0","315":"794b8ea5","600":"8f70cbc5","618":"8f70cbc5","984":"8f70cbc5"}[chunkId] + ".chunk.css";
};